var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconeCancelado(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1491_918)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "#FF5151"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 49.5,
    stroke: "#7D7D7D"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 80,
    height: 80,
    rx: 25,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1491_918",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1491_918"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1491_918",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1491_918",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1491_918",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeCancelado);
export default __webpack_public_path__ + "static/media/iconeCancelado.4a134e4f6c065e8df696c6f0e69b24af.svg";
export { ForwardRef as ReactComponent };